var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('el-form-item', _vm._b({}, 'el-form-item', _vm.innerConfig, false), [_c('el-select', _vm._g(_vm._b({ model: { value: _vm.formValue[_vm.innerConfig.prop], callback: function callback($$v) {
        _vm.$set(_vm.formValue, _vm.innerConfig.prop, $$v);
      }, expression: "formValue[innerConfig.prop]" } }, 'el-select', _vm.innerConfig.params, false), _vm.innerConfig.params.listeners), _vm._l(_vm.innerConfig.params.options, function (item) {
    return _c('el-option', { key: item._id ? item._id : item.value, attrs: { "label": item.label, "value": item.value } });
  }), 1)], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };